import { render, staticRenderFns } from "./StatusAlert.vue?vue&type=template&id=7c972517&"
import script from "./StatusAlert.vue?vue&type=script&lang=js&"
export * from "./StatusAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VSnackbar})
